<template>
  <section>
    <h1 class="section-head">{{ title }}</h1>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <router-link class="button is-danger is-pulled-left" :to="backPage"
            ><i class="fas fa-arrow-left"></i>Back</router-link
          >
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            <button
              class="button is-success is-pulled-right"
              :class="loadingClass"
              @click="submit"
            >
              <i class="fas fa-clipboard-list"></i>บันทึก
            </button>
          </div>
        </div>
      </div>
    </nav>

    <div class="column">
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Username</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input
                name="username"
                class="input "
                type="text"
                placeholder="Username"
                v-model="user.username"
                :disabled="isEditing"
                v-validate="'required|min:4|max:35'"
              />
              <span class="icon is-small is-left">
                <i class="fas fa-key"></i>
              </span>
            </p>
            <span>{{ errors.first("username") }}</span>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Password</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input
                name="password"
                class="input"
                type="password"
                placeholder="Password"
                v-model="user.password"
                v-validate="isRequired + 'min:6|max:35'"
                ref="password"
              />
              <span class="icon is-small is-left">
                <i class="fas fa-key"></i>
              </span>
            </p>
            <span>{{ errors.first("password") }}</span>
          </div>

          <div class="field-label is-normal">
            <label class="label">Re-Password</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control">
                <input
                  name="repassword"
                  class="input"
                  type="password"
                  placeholder="Re-Password"
                  v-model="user.repassword"
                  v-validate="isRequired + 'confirmed:password'"
                  data-vv-as="password"
                />
              </p>
              <span>{{ errors.first("repassword") }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">ชื่อ</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input
                class="input "
                type="text"
                placeholder="ชื่อ"
                v-model="user.first_name"
              />
              <span class="icon is-small is-left">
                <i class="fas fa-user"></i>
              </span>
            </p>
          </div>

          <div class="field-label is-normal">
            <label class="label">นามสกุล</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control">
                <input
                  class="input "
                  type="text"
                  placeholder="นามสกุล"
                  v-model="user.last_name"
                />
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">ที่อยู่</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input
                class="input "
                type="text"
                placeholder="ที่อยู่"
                v-model="user.address"
              />
              <span class="icon is-small is-left">
                <i class="fas fa-map-marker-alt"></i>
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">เบอร์โทรศัพท์</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input
                class="input "
                type="text"
                placeholder="เบอร์โทรศัพท์"
                v-model="user.phone"
              />
              <span class="icon is-small is-left">
                <i class="fas fa-phone"></i>
              </span>
            </p>
          </div>

          <div class="field"></div>
          <div class="field"></div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">E-Mail</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input
                name="email"
                class="input"
                type="text"
                placeholder="E-Mail"
                v-model="user.email"
                :disabled="isEditing"
                v-validate="'required|email'"
              />
              <span class="icon is-small is-left">
                <i class="fas fa-envelope"></i>
              </span>
            </p>
          </div>
          <div class="field">
            <span>{{ errors.first("email") }}</span>
          </div>
          <div class="field"></div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">กลุ่มผู้ใช้งาน</label>
        </div>
        <div class="field-body">
          <b-select placeholder="กลุ่มผู้ใช้งาน" v-model="user.group">
            <option v-for="group in groups" :value="group.id" :key="group.id">
              {{ group.description }}
            </option>
          </b-select>
        </div>
      </div>
    </div>

    <b-loading
      :is-full-page="false"
      :active.sync="isLoading"
      :canCancel="false"
    ></b-loading>
  </section>
</template>

<script>
import Request from "@/libraries/request";
import UserModel from "@/model/user_model";

export default {
  name: "User_Add",
  data() {
    return {
      user: {
        username: "",
        password: "",
        repassword: "",
        first_name: "",
        last_name: "",
        address: "",
        phone: "",
        email: "",
        groupd: 0
      },
      title: "เพิ่มผู้ใช้งาน",
      backPage: "/user",
      loadingClass: "",
      isLoading: true,
      isEditing: this.$route.params.id ? true : false,
      groups: [],

      submitted: false
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    isRequired() {
      return this.$route.params.id ? "" : "required|";
    }
  },
  methods: {
    async init() {
      if (this.$route.params.id) {
        this.user = await UserModel.get_users(this.$route.params.id);
        this.user = this.user[0];
        this.title =
          "แก้ไขผู้ใช้งาน - " +
          this.user.first_name +
          " " +
          this.user.last_name;
      } else {
      }
      this.groups = await UserModel.get_groups();
      this.isLoading = false;
    },
    submit() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          //alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.user))
          this.isLoading = true;
          let data = {
            id: this.$route.params.id ? this.$route.params.id : "",
            username: this.user.username,
            password: this.user.password,
            first_name: this.user.first_name,
            last_name: this.user.last_name,
            address: this.user.address,
            phone: this.user.phone,
            email: this.user.email,
            group: this.user.group
          };
          Request.post("user/add", data, res => {
            if (res.data.status) {
              this.isLoading = false;
              this.$buefy.snackbar.open("บันทึกสำเร็จ!");
              this.$router.push("/user");
            } else {
              this.$buefy.toast.open("ไม่สามารถบันทึกได้! - " + res.data.msg);
            }
          });
        } else {
          this.$buefy.toast.open("กรุณากรอกข้อมูลให้ครบถ้วน!");
        }
      });
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/User/add.vue